"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4467,2054,5909,5635,7480],{

/***/ 29050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ProductImage": function() { return /* binding */ ProductImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hooks_useProduct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77690);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);



var ProductImagesCarousel = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(__webpack_require__.e(/* import() */ 8927).then(__webpack_require__.bind(__webpack_require__, 18927)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18927)
            ];
        }
    }
});
var formatImagesArrayForDls = function(productName) {
    return function(param, index) {
        var url = param.url_square, thumbNail = param.url_thumbnail, zoom = param.url_zoom;
        return {
            url: url,
            thumbNail: thumbNail,
            zoom: zoom,
            title: "Product_image_".concat(productName, "_").concat(index)
        };
    };
};
var ProductImage = function() {
    var ref;
    var ref1 = (0,_hooks_useProduct__WEBPACK_IMPORTED_MODULE_1__.useProduct)(), product = ref1.product, selectedVariantId = ref1.variantId;
    var selectedVariantImages = ((ref = product === null || product === void 0 ? void 0 : product.variants.find(function(param) {
        var id = param.id;
        return "".concat(selectedVariantId) === "".concat(id);
    })) === null || ref === void 0 ? void 0 : ref.images) || [];
    var images = selectedVariantImages.map(formatImagesArrayForDls((product === null || product === void 0 ? void 0 : product.name) || ""));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductImagesCarousel, {
        id: "pdp-main-product-image",
        images: images
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ProductImage);


/***/ }),

/***/ 32054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DEFAULT_CHECKOUT_VARIANT": function() { return /* binding */ DEFAULT_CHECKOUT_VARIANT; },
/* harmony export */   "checkVariantNameIsSize": function() { return /* binding */ checkVariantNameIsSize; },
/* harmony export */   "formatPrice": function() { return /* binding */ formatPrice; },
/* harmony export */   "formatPriceRange": function() { return /* binding */ formatPriceRange; },
/* harmony export */   "formatPriceValue": function() { return /* binding */ formatPriceValue; },
/* harmony export */   "getCookieByName": function() { return /* binding */ getCookieByName; },
/* harmony export */   "getCustomerDetails": function() { return /* binding */ getCustomerDetails; },
/* harmony export */   "getCustomerOrderCount": function() { return /* binding */ getCustomerOrderCount; },
/* harmony export */   "getPriceOrPriceRange": function() { return /* binding */ getPriceOrPriceRange; },
/* harmony export */   "getWindowAgent": function() { return /* binding */ getWindowAgent; },
/* harmony export */   "priceValue": function() { return /* binding */ priceValue; },
/* harmony export */   "productClickGa": function() { return /* binding */ productClickGa; },
/* harmony export */   "productUpdateGA": function() { return /* binding */ productUpdateGA; },
/* harmony export */   "removeSpecialChars": function() { return /* binding */ removeSpecialChars; },
/* harmony export */   "sizeArray": function() { return /* binding */ sizeArray; },
/* harmony export */   "sleep": function() { return /* binding */ sleep; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var _codebuild_output_src2623904418_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src2623904418_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src2623904418_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27429);
/* harmony import */ var _allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48080);






var getCustomerDetails = function() {
    try {
        var customerDetails = localStorage.getItem("customer");
        if (customerDetails) {
            var ref = JSON.parse(customerDetails), customerId = ref.customerId, customerEmail = ref.customerEmail;
            if ((typeof customerId === "number" || typeof customerId === "string") && typeof customerEmail === "string") {
                return {
                    customerId: customerId,
                    customerEmail: customerEmail
                };
            }
        }
    } catch (err) {
        (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .error */ .vU)("Failed to get customer details from localStorage");
    }
    return {
        customerId: 0,
        customerEmail: ""
    };
};
var kebabCase = function(str) {
    return "".concat(str || "").replace(/([a-z])([A-Z])/g, "$1-$2") // get all lowercase letters that are near to uppercase ones
    .replace(/[\s_]+/g, "-") // replace all spaces and low dash
    .toLowerCase();
};
var productClickGa = function(param) {
    var product = param.product, position = param.position, category = param.category;
    var sendToGA = function() {
        if (true) {
            var customer = getCustomerDetails();
            var customerId = customer === null || customer === void 0 ? void 0 : customer.customerId;
            var customerEmail = customer === null || customer === void 0 ? void 0 : customer.customerEmail;
            var visitorType = customerEmail ? "Logged In" : "Guest";
            // Define the event object with the correct structure.
            var eventData = {
                event: "productClick",
                ecommerce: {
                    visitorType: visitorType,
                    customerId: customerId,
                    click: {
                        actionField: {
                            list: kebabCase(category)
                        },
                        products: [
                            {
                                name: product.name,
                                id: product.variants[0].sku,
                                price: product.calculated_price,
                                brand: product.brand || "",
                                category: category,
                                variant: product.variants[0].id,
                                position: position
                            }
                        ]
                    }
                },
                customerEmail: customerEmail
            };
            // Push event data to the dataLayer with type safety.
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                ecommerce: null
            }) // Clear the previous ecommerce object.
            ;
            window.dataLayer.push(eventData);
        }
    };
    if (window.loadedAndInteractive) {
        sendToGA();
    } else {
        window.addEventListener("loadedAndInteractive", sendToGA, {
            once: true
        });
    }
};
var productUpdateGA = function(lineItem, event, cartTotal) {
    var sendToGA = function() {
        try {
            var customer = getCustomerDetails();
            var customerId = customer === null || customer === void 0 ? void 0 : customer.customerId;
            var customerEmail = customer === null || customer === void 0 ? void 0 : customer.customerEmail;
            var visitorType = customerEmail ? "Logged In" : "Guest";
            var keyName = event === "addToCart" ? "add" : "remove";
            var _obj;
            // Create the correct GA event based on the input event type.
            var eventData = {
                event: event,
                ecommerce: (_obj = {
                    visitorType: visitorType,
                    customerId: customerId
                }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, keyName, {
                    products: [
                        {
                            name: lineItem.name,
                            // for grouped products like quilts, do you have a default that you can use?
                            id: lineItem.sku,
                            // for grouped products like quilts, do you have a default that you can use?
                            price: lineItem.originalPrice,
                            // for grouped products like quilts, do you have a default that you can use?
                            salePrice: lineItem.salePrice,
                            brand: lineItem.brand,
                            variant: lineItem.variantId,
                            quantity: lineItem.quantity
                        }
                    ]
                }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, "customerEmail", customerEmail), _obj),
                cartTotal: cartTotal
            };
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                ecommerce: null
            }) // Clear the previous ecommerce object.
            ;
            window.dataLayer.push(eventData);
        } catch (err) {
            (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .error */ .vU)("Failed to send GA event", err);
        }
    };
    if (window.loadedAndInteractive) {
        sendToGA();
    } else {
        window.addEventListener("loadedAndInteractive", sendToGA, {
            once: true
        });
    }
};
var getCustomerOrderCount = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_codebuild_output_src2623904418_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var orderCountFromStorage, ref, getCustomer, getCustomerOrders, ref1, customer, success, orderCount;
        return _codebuild_output_src2623904418_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    orderCountFromStorage = sessionStorage.getItem("customerOrderCount");
                    if (!(orderCountFromStorage !== null && orderCountFromStorage)) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return", parseInt(orderCountFromStorage));
                case 3:
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z;
                    _ctx.next = 6;
                    return (0,_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
                        return [
                            __webpack_require__.e(/* import() */ 7941).then(__webpack_require__.bind(__webpack_require__, 57941)),
                            __webpack_require__.e(/* import() */ 1950).then(__webpack_require__.bind(__webpack_require__, 41950)), 
                        ];
                    });
                case 6:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 2);
                    getCustomer = ref[0].getCustomer;
                    getCustomerOrders = ref[1].getCustomerOrders;
                    _ctx.next = 12;
                    return getCustomer();
                case 12:
                    ref1 = _ctx.sent;
                    customer = ref1.customer;
                    success = ref1.success;
                    if (!(!success || !customer)) {
                        _ctx.next = 17;
                        break;
                    }
                    return _ctx.abrupt("return", 0);
                case 17:
                    _ctx.next = 19;
                    return getCustomerOrders({
                        sort: "date_created:desc"
                    });
                case 19:
                    orderCount = _ctx.sent.length;
                    sessionStorage.setItem("customerOrderCount", "".concat(orderCount));
                    return _ctx.abrupt("return", orderCount);
                case 22:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getCustomerOrderCount() {
        return _ref.apply(this, arguments);
    };
}();
var formatPrice = function(price) {
    var digit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    // using parseFloat to make sure this function works for both number and string
    var floatPrice = parseFloat("".concat(price || ""));
    if (!Number.isFinite(floatPrice)) {
        return price;
    }
    return "$".concat(parseFloat("".concat(price || "")).toFixed(digit));
};
var formatPriceValue = function(price) {
    var digit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    var floatPrice = parseFloat(String(price));
    if (!Number.isFinite(floatPrice)) {
        return price;
    }
    return Number(parseFloat(String(price)).toFixed(digit));
};
// using parseFloat to make sure this function works for both number and string
var formatPriceRange = function(minPrice, maxPrice) {
    var digit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
    return "".concat(formatPrice(minPrice, digit) || "", " - ").concat(formatPrice(maxPrice, digit) || "");
};
var getPriceOrPriceRange = function(product, priceType) {
    var ref;
    var variants = product.variants;
    var sortedVariantPrices = (ref = variants === null || variants === void 0 ? void 0 : variants.map(function(variant) {
        return parseFloat("".concat(variant[priceType]));
    })) === null || ref === void 0 ? void 0 : ref.sort();
    var minPrice = variants ? sortedVariantPrices[0] : product[priceType];
    var maxPrice = variants ? sortedVariantPrices.pop() : product[priceType];
    return minPrice === maxPrice ? formatPrice(minPrice) : formatPriceRange(minPrice, maxPrice);
};
var sizeArray = [
    "small",
    "medium",
    "large",
    "extra small",
    "extra large",
    "long",
    "tall",
    "short"
];
var checkVariantNameIsSize = function(el) {
    var name = el.option_values[0].label.toLowerCase();
    if (/^\d/.test(name) || sizeArray.includes(name)) {
        return true;
    }
    return false;
};
var priceValue = function(price) {
    return price.split("$")[1];
};
var removeSpecialChars = function(string) {
    var regex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : /[^a-zA-Z \s0-9,'\-#.*&]/g;
    return "".concat(string).replace(regex, "");
};
var getCookieByName = function(name, cookiesFromRequest) {
    var cookies;
    if (globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
        var _cookie;
        cookies = (_cookie = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document.cookie) !== null && _cookie !== void 0 ? _cookie : "";
    } else {
        cookies = cookiesFromRequest !== null && cookiesFromRequest !== void 0 ? cookiesFromRequest : "";
    }
    if (cookies) {
        var ref, ref1;
        var ref2;
        var cookieName = (ref2 = (ref = cookies.split(";")) === null || ref === void 0 ? void 0 : ref.find(function(cookie) {
            return cookie.includes(name);
        })) !== null && ref2 !== void 0 ? ref2 : "";
        return (ref1 = cookieName === null || cookieName === void 0 ? void 0 : cookieName.split("=")) === null || ref1 === void 0 ? void 0 : ref1[1];
    }
    return "";
};
// IDs for each variant within an experiment are numeric and indexed at 0
var DEFAULT_CHECKOUT_VARIANT = "0";
var sleep = function(ms) {
    return new Promise(function(r) {
        return setTimeout(r, ms);
    });
};
var getWindowAgent = function(nextContextReq) {
    // Ref: https://stackoverflow.com/questions/59494037/how-to-detect-the-device-on-react-ssr-app-with-next-js
    // if you are on the server and you get a 'nextContextReq' property from your context
    if (nextContextReq) {
        // get the user-agent from the headers
        return nextContextReq.headers["user-agent"];
    }
    // if you are on the client you can access the navigator from the window object
    return navigator.userAgent;
};


/***/ }),

/***/ 63548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "formatMoney": function() { return /* binding */ formatMoney; }
/* harmony export */ });
// formatMoney takes a numeric value and returns a printable string
// formatMoney(123456.78) => $123,456.78
var BLANK_MONEY_VALUE = "--";
var formatMoney = function(value) {
    return typeof value === "number" ? new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2
    }).format(parseFloat("".concat(value || "0"))) : BLANK_MONEY_VALUE;
};
/* harmony default export */ __webpack_exports__["default"] = (formatMoney);


/***/ }),

/***/ 15909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sendDMPAnalyticsEvent": function() { return /* binding */ sendDMPAnalyticsEvent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29815);
/* harmony import */ var _codebuild_output_src2623904418_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src2623904418_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src2623904418_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27429);
/* harmony import */ var _recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30901);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16977);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_services_Configuration__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48080);
/* harmony import */ var _helpers_FP__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13174);
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];











var Event = (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .object */ .Ry)({
    uuid: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)(),
    userUUID: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)(),
    date: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)(),
    eventType: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)(),
    url: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)(),
    items: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .array */ .IX)((0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .object */ .Ry)({
        sku: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)(),
        salePrice: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .number */ .Rx)(),
        price: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .number */ .Rx)(),
        quantity: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .number */ .Rx)()
    })),
    context: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .array */ .IX)((0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .object */ .Ry)({
        key: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)(),
        value: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .object */ .Ry)({
            stringValue: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .nullable */ .AG)((0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)()),
            numberValue: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .nullable */ .AG)((0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .number */ .Rx)()),
            booleanValue: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .nullable */ .AG)((0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .bool */ .Xg)())
        })
    }))
});
var assertEvent = (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .assertion */ .P5)(Event, "Invalid DMP Analytics Event");
var client = null;
var uuidRegex = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/;
var localStorageDMPUserUUIDKey = "dmpUserUUID";
var getLocalStorageUserUUID = function() {
    try {
        var value = localStorage.getItem(localStorageDMPUserUUIDKey);
        if (value && uuidRegex.test(value)) {
            return value;
        }
    } catch (e) {
        return null;
    }
    return null;
};
var loadUserUUID = function(uuidGenerator) {
    var fromLocalStorage = getLocalStorageUserUUID();
    if (fromLocalStorage) {
        return fromLocalStorage;
    }
    var generated = uuidGenerator();
    localStorage.setItem(localStorageDMPUserUUIDKey, generated);
    return generated;
};
var sendEventHappyPath = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_codebuild_output_src2623904418_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(event) {
        var ref, ref1, FirehoseClient, PutRecordBatchCommand, fromCognitoIdentityPool, ref2, uuidv4, getComposeAssignmentMap, trackAmplitudeFromDMPEvent, eventData, sendFirehosePromise, amplitudePromise, results;
        return _codebuild_output_src2623904418_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z;
                    _ctx.next = 3;
                    return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                        return [
                            Promise.all(/* import() */[__webpack_require__.e(4354), __webpack_require__.e(5330)]).then(__webpack_require__.bind(__webpack_require__, 65330)),
                            Promise.all(/* import() */[__webpack_require__.e(3601), __webpack_require__.e(3424)]).then(__webpack_require__.bind(__webpack_require__, 83601)),
                            __webpack_require__.e(/* import() */ 6578).then(__webpack_require__.bind(__webpack_require__, 46578)),
                            __webpack_require__.e(/* import() */ 5434).then(__webpack_require__.bind(__webpack_require__, 85434)),
                            __webpack_require__.e(/* import() */ 9378).then(__webpack_require__.bind(__webpack_require__, 29378)), 
                        ];
                    });
                case 3:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 5);
                    ref1 = ref[0];
                    FirehoseClient = ref1.FirehoseClient;
                    PutRecordBatchCommand = ref1.PutRecordBatchCommand;
                    fromCognitoIdentityPool = ref[1].fromCognitoIdentityPool;
                    ref2 = ref[2];
                    uuidv4 = ref2.v4;
                    getComposeAssignmentMap = ref[3].getComposeAssignmentMap;
                    trackAmplitudeFromDMPEvent = ref[4].trackAmplitudeFromDMPEvent;
                    eventData = assertEvent((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                        url: window.location.href,
                        uuid: String(event.uuid || (uuidv4 === null || uuidv4 === void 0 ? void 0 : uuidv4())),
                        userUUID: loadUserUUID(uuidv4),
                        date: new Date().toISOString()
                    }, event), {
                        context: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(event.context).concat([
                            {
                                key: "A/B tests",
                                value: {
                                    stringValue: JSON.stringify(getComposeAssignmentMap())
                                }
                            }, 
                        ])
                    }));
                    trackAmplitudeFromDMPEvent(eventData);
                    client = client || new FirehoseClient({
                        region: _services_Configuration__WEBPACK_IMPORTED_MODULE_3__.FIREHOSE_REGION,
                        credentials: fromCognitoIdentityPool({
                            clientConfig: {
                                region: _services_Configuration__WEBPACK_IMPORTED_MODULE_3__.COGNITO_REGION
                            },
                            identityPoolId: _services_Configuration__WEBPACK_IMPORTED_MODULE_3__.COGNITO_IDENTITY_POOL_ID
                        })
                    });
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .log */ .cM)("sendDMPAnalyticsEvent: Firehose client created");
                    if (!client) {
                        _ctx.next = 26;
                        break;
                    }
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .log */ .cM)("Sending page view");
                    sendFirehosePromise = client.send(new PutRecordBatchCommand({
                        DeliveryStreamName: _services_Configuration__WEBPACK_IMPORTED_MODULE_3__.FIREHOSE_DELIVERY_STREAM_NAME,
                        Records: [
                            {
                                Data: Buffer.from(JSON.stringify(eventData))
                            }, 
                        ]
                    }));
                    amplitudePromise = trackAmplitudeFromDMPEvent(eventData);
                    _ctx.next = 23;
                    return Promise.allSettled([
                        sendFirehosePromise,
                        amplitudePromise, 
                    ]);
                case 23:
                    results = _ctx.sent;
                    results.forEach(function(result) {
                        if (result.status === "rejected") {
                            (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .error */ .vU)("result", result);
                        }
                    });
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .log */ .cM)("sendDMPAnalyticsEvent: Page view sent");
                case 26:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function sendEventHappyPath(event) {
        return _ref.apply(this, arguments);
    };
}();
var sendEventSadPath = function(err) {
    (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .error */ .vU)("sendDMPAnalyticsEvent: Error sending event: ".concat(String(err)));
};
var sendDMPAnalyticsEvent = (0,_helpers_FP__WEBPACK_IMPORTED_MODULE_5__/* .thenCaught */ .HA)(sendEventHappyPath)(sendEventSadPath);


/***/ })

}]);